interface LegalLinksProps {
  termsText: string
  termsOfService: string
  privacyPolicy: string
  dataDeletionAgreement: string
  andText: string
}

export function LegalLinks({
  termsText,
  termsOfService,
  privacyPolicy,
  dataDeletionAgreement,
  andText,
}: LegalLinksProps) {
  return (
    <div className="text-muted-foreground *:[a]:hover:text-primary text-center text-xs text-balance *:[a]:underline *:[a]:underline-offset-4">
      {termsText}{" "}
      <a href="/terms-of-service" rel="noopener noreferrer">
        {termsOfService}
      </a>
      ,{" "}
      <a href="/privacy-policy" rel="noopener noreferrer">
        {privacyPolicy}
      </a>
      , {andText}{" "}
      <a href="/data-deletion-agreement" rel="noopener noreferrer">
        {dataDeletionAgreement}
      </a>
      .
    </div>
  )
}
